import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AdminService } from 'src/app/public/landing/services/admin.service';
import { AdminViewModel } from 'src/app/models/AdminViewModel';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Vesselslist } from 'src/app/models/vesselslist';
import { VesselService } from 'src/app/public/landing/services/vessel.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-vessels-list',
  templateUrl: './vessels-list.component.html',
  styleUrls: ['./vessels-list.component.scss']
})
export class VesselsListComponent implements OnInit {
  VesselsData: any;
  totalcount: number = 0;
  shippinglineslist: any = [];
  selectedShippingline: any;
  shippingLine: any;
  shippingname: any = [];
  primaryShippingLine: any = [];
  VesselsId: number = 0;
  submitted: boolean = false;
  showModal: boolean;
  requestVM: AdminViewModel;
  isVesselsSaved:boolean=true;
  myshippingline:any;
  myselectedshippingline:any=[];

  VesselsForm = this.fb.group({
    vesselsName:['', [Validators.required, Validators.maxLength(30)]],
    cbmCapacity: [''],
    ceuCapacity: [''],
    misiNumber: [''],
    shippingLine: ['', Validators.required],
    myshippingline: ['', Validators.required],
  })
  constructor(private fb: FormBuilder, private toastr: ToastrService, private adminService: AdminService, private spinner: NgxSpinnerService,
     private router: Router, private vesselService: VesselService,
       private modalService: NgbModal) { }

  ngOnInit() {
    // this.shippinglineslist=[{label:'Select City', value:null}];
    this.requestVM = new AdminViewModel();
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.getShippingline();
    this.getVesselsList();

  }
  @ViewChild('closeVesselsModal') closeVesselsModal: ElementRef;
  vesselModalMode: 'add' | 'edit' = 'add';
  @ViewChild('vesselModal', { static: false }) vesselModal: any;
  modalRef: NgbModalRef | null = null;


  get fg() { return this.VesselsForm.controls; }

  getShippingline() {
    this.adminService.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippinglineslist = response.content;
        this.myshippingline = response.content;
        //this.shippingname = response.content;
      }
      else {
        this.shippinglineslist = null;
      }
    });
  }
  // AddVesselsRequest() {
  //   // let id = 0;
  //   let url = '/vesselsadd/' + 0;
  //   this.router.navigate([url]);
  // }
  onChangeshippingline() {
    if (this.selectedShippingline != null && this.selectedShippingline != undefined && this.selectedShippingline.shippingLineId > 0) {
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.requestVM.shippinglineId = this.selectedShippingline.shippingLineId;
    }
    else {
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.requestVM.shippinglineId = this.selectedShippingline.id;
    }
    this.getVesselsList();
  }

  openVesselModal(id: number, mode: 'add' | 'edit') {
    this.vesselModalMode = mode;
    this.getVesselsdetails(id); 

    this.modalRef = this.modalService.open(this.vesselModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }
  
  getVesselsList() {
    if (this.requestVM != null && this.requestVM.pageNo > 0 && this.requestVM.pageSize > 0) {
      this.spinner.show();
      this.vesselService.GetVessselsList(this.requestVM).subscribe((response: any) => {
        if (response != null && response.succeeded  && response.data != null) {
          this.VesselsData = response.data;
          this.totalcount = response.totalRecords;
          this.spinner.hide();
        }
        this.spinner.hide();
      })
    }
  }
  paginate(event) {
    this.requestVM.pageNo = event.page + 1;
    this.requestVM.pageSize = event.rows;
    this.getVesselsList();
  }
  filterSearch(searchText) {
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.requestVM.searchText = searchText;
    this.getVesselsList();
  }

  getVesselsdetails(id) {
    if (id > 0) {
      this.VesselsId = id;
      this.vesselService.GetVesselsdetailsByVesselsId(this.VesselsId).subscribe((response: any) => {
        if (response != null && response.succeeded && response.data) {
          this.VesselsForm.controls.vesselsName.setValue(response.data.vesselsName);
          this.VesselsForm.controls.cbmCapacity.setValue(response.data.cbmCapacity);
          this.VesselsForm.controls.ceuCapacity.setValue(response.data.ceuCapacity);
          this.VesselsForm.controls.misiNumber.setValue(response.data.misiNumber);

          let temp = this.VesselsData.filter(x=>x.vesselsId == this.VesselsId);
          this.shippingname = this.shippinglineslist.filter(x => temp[0].shippingLineIds.includes(x.shippingLineId));
          this.primaryShippingLine = this.shippinglineslist.filter(x => x.shippingLineId == response.data.primaryShippingLineId);

          if (this.shippingname != null && this.shippingname.length > 0) {
            this.VesselsForm.controls.shippingLine.setValue(this.primaryShippingLine[0]);
            this.VesselsForm.controls.myshippingline.setValue(this.shippingname);
          }

        }
        else {
          this.toastr.error('Something went wrong!', 'Oops!!');
        }


      });
    }
    else {
      this.VesselsId = id;
      this.VesselsForm.reset();
    }

  }  
  resetvalues(){
    this.submitted = false;
    this.VesselsForm.reset();
    this.isVesselsSaved = true;
  }


  updateVessel() {
    this.submitted = true;
    if (this.VesselsForm.invalid || ! this.VesselsId) {
      this.toastr.warning('Please Enter All the Required Fields.', 'Oops !');
      return;
    }
    else {
      let vsslmodel = new Vesselslist();
      this.isVesselsSaved = false;
      vsslmodel.Id = this.VesselsId;
      vsslmodel.VesselsName = (this.VesselsForm.controls.vesselsName.value);
       vsslmodel.CbmCapacity = (this.VesselsForm.controls.cbmCapacity.value!= null && this.VesselsForm.controls.cbmCapacity.value != '')?  parseFloat(this.VesselsForm.controls.cbmCapacity.value):0;
       vsslmodel.CEUCapacity =(this.VesselsForm.controls.ceuCapacity.value != null && this.VesselsForm.controls.ceuCapacity.value != '')? parseFloat(this.VesselsForm.controls.ceuCapacity.value):0;
      vsslmodel.MisiNumber = (this.VesselsForm.controls.misiNumber.value);
      vsslmodel.ShippingLineId = parseInt((this.VesselsForm.controls.shippingLine.value as any)?.shippingLineId);
      vsslmodel.ShippingLineIds = (this.VesselsForm.controls.myshippingline.value as any)?.map(p=>p.shippingLineId);
      this.vesselService.UpdateVessel(vsslmodel).subscribe((response: any) => {
        if (response != null && response.succeeded) {
          // this.closeVesselsModal.nativeElement.click();
          this.modalRef.close();
          this.toastr.success("Vessel update successfully", 'Info');
        }
        else {
          // this.closeVesselsModal.nativeElement.click();
          this.modalRef.close();
        }
        this.getVesselsList();
      })
    }
  }

  addVessel() {
    this.submitted = true;
    if (this.VesselsForm.invalid) {
      this.toastr.warning('Please Enter All the Required Fields.', 'Oops !');
      return;
    }
    else {
      let vsslmodel = new Vesselslist();
      this.isVesselsSaved = false;
      vsslmodel.VesselsName = (this.VesselsForm.controls.vesselsName.value);
       vsslmodel.CbmCapacity = (this.VesselsForm.controls.cbmCapacity.value!= null && this.VesselsForm.controls.cbmCapacity.value != '')?  parseFloat(this.VesselsForm.controls.cbmCapacity.value):0;
       vsslmodel.CEUCapacity =(this.VesselsForm.controls.ceuCapacity.value != null && this.VesselsForm.controls.ceuCapacity.value != '')? parseFloat(this.VesselsForm.controls.ceuCapacity.value):0;
      vsslmodel.MisiNumber = (this.VesselsForm.controls.misiNumber.value);
      vsslmodel.ShippingLineId = parseInt((this.VesselsForm.controls.shippingLine.value as any)?.shippingLineId);
      vsslmodel.ShippingLineIds = (this.VesselsForm.controls.myshippingline.value as any)?.map(p=>p.shippingLineId);
      this.vesselService.AddVessel(vsslmodel).subscribe((response: any) => {
        if (response != null && response.succeeded) {
          // this.closeVesselsModal.nativeElement.click();
          this.modalRef.close();
          this.toastr.success('Vessel added successfully.', 'Info');
        }
        else {
          // this.closeVesselsModal.nativeElement.click();
          this.modalRef.close();
        }
        this.getVesselsList();
      })
    }
  }

}



